var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAbsoluteURL)?_c('a',{attrs:{"href":_vm.href,"target":_vm.currentTarget,"rel":_vm.rel
    ? _vm.rel
    : 'nofollow'}},[_vm._t("default")],2):_c('nuxt-link',{attrs:{"to":_vm.href,"target":_vm.currentTarget,"rel":_vm.rel,"exact":_vm.exact,"append":_vm.append,"replace":_vm.replace,"active-class":_vm.activeClass,"exact-active-class":_vm.exactActiveClass}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }